var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.service)?_c('div',{attrs:{"id":"ServiceInfo"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.p.orgName))]),_c('v-card-text',[_vm._v(_vm._s(_vm.p.orgAddress))])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }